import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from '@api';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';
import { UserResourceService } from '../resources/user-resource.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userResourceService = inject(UserResourceService);
  private cookies = inject(CookieService);
  private config = inject(Configuration);
  private router = inject(Router);

  private user = this.userResourceService.user;

  constructor() {
    this.init();
  }

  private getAPIBearerToken() {
    return this.cookies.get(environment.authCookie.name);
  }

  private init() {
    this.config.credentials['http'] = this.getAPIBearerToken();
  }

  public isAuthenticated = computed(() => {
    // Wait for user to be loaded and check if it exists
    return !this.user.isLoading() && this.user.hasValue() && this.user.value() !== undefined;
  });

  public waitUntilLoaded = () => {
    return this.user.waitUntilLoaded();
  };

  public logout() {
    this.cookies.delete(
      environment.authCookie.name,
      environment.authCookie.path,
      environment.authCookie.domain,
    );
    this.config.credentials['http'] = '';

    this.user.destroy();
    this.router.navigate(['/public']);
  }
}
